
// left/right indexed from center outward → reverse to get outer-first order matching tire IDs
function flattenTireIds(tires) {
	const ids = []
	for (const axle of (tires || [])) {
		if (!axle) continue
		if (axle.left)   ids.push(...[...axle.left].reverse())
		if (axle.right)  ids.push(...axle.right)
		if (axle.middle) ids.push(axle.middle)
	}
	return ids
}

export default {
	state: {
		unitsTypes: [],
		unitsXTypes: [],
		unitsHwTypesSettings: {},
		chassisTypes: [],
		unitsOfMeasures: {},
	},
	actions: {
		fetchUnitsTypes({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}

				dispatch('setLastCall', {name: 'fetchUnitsTypes', time: Date.now() / 1000})

				this.$api.unitshelper.getTypes()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsTypes', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsTypes', inprogress: false})
					});
			})
		},
		fetchUnitsXTypes({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}

				dispatch('setLastCall', {name: 'fetchUnitsTypes', time: Date.now() / 1000})

				this.$api.unitshelper.getXtypes()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsXTypes', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsTypes', inprogress: false})
					});
			})
		},
		fetchUnitsHwTypesSettings({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}

				dispatch('setLastCall', {name: 'fetchUnitsHwTypesSettings', time: Date.now() / 1000})

				this.$api.unitshelper.getHwTypesSettings()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsHwTypesSettings', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsHwTypesSettings', inprogress: false})
					});
			})
		},

		fetchChassisTypes({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) return reject(false)
				dispatch('setLastCall', {name: 'fetchChassisTypes', time: Date.now() / 1000})
				this.$api.unitshelper.getChassisTypes()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateChassisTypes', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error)
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchChassisTypes', inprogress: false})
					})
			})
		},

		fetchUnitsOfMeasures({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) return reject(false)
				dispatch('setLastCall', {name: 'fetchUnitsOfMeasures', time: Date.now() / 1000})
				this.$api.unitshelper.getUnitsOfMeasures()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsOfMeasures', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error)
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsOfMeasures', inprogress: false})
					})
			})
		},

		fetchUnitTypesByHwType({getters}, args) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken && !args?.hw_type) {
					return reject(false)
				}

				//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, time: Date.now() / 1000})

				this.$api.unitshwtypes.getTypes(args.hw_type, {})
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, inprogress: false})
					});
			})
		},
		fetchUnitAttrsByHwType({getters}, args) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken && !args?.hw_type) {
					return reject(false)
				}

				//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, time: Date.now() / 1000})
				const hw_type = args.hw_type; delete args.hw_type;
				this.$api.unitshwtypes.getAttrs(hw_type, args)
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, inprogress: false})
					});
			})
		},

	},
	mutations: {
		updateUnitsTypes(state, unitsTypes) {
			state.unitsTypes = unitsTypes
		},
		updateUnitsXTypes(state, unitsXTypes) {
			state.unitsXTypes = unitsXTypes
		},
		updateUnitsHwTypesSettings(state, unitsHwTypesSettings) {
			state.unitsHwTypesSettings = unitsHwTypesSettings
		},
		updateChassisTypes(state, chassisTypes) {
			state.chassisTypes = chassisTypes
		},
		updateUnitsOfMeasures(state, unitsOfMeasures) {
			state.unitsOfMeasures = unitsOfMeasures
		},
	},
	getters: {
		getUnitsTypes(state) {
			return state.unitsTypes
		},
		getUnitsXTypes(state) {
			return state.unitsXTypes
		},
		getUnitsTypesByType(state) {
			return state.unitsTypes.reduce((out, type) => {
				out[type.id] = type
				return out;
			}, {})
		},
		getUnitsHwTypesSettings(state) {
			return state.unitsHwTypesSettings
		},
		getChassisTypes(state) {
			return state.chassisTypes
		},
		getChassisTypesByType(state) {
			return state.chassisTypes.reduce((acc, ct) => {
				acc[ct.type] = {...ct, tireIds: flattenTireIds(ct.tires)}
				return acc
			}, {})
		},
		getUnitsOfMeasures(state) {
			return state.unitsOfMeasures
		},
	},
}